<template>
  <div class="component-set-up">
    <div class="flex row-flex-justify-content-center row-flex-align-items-center">
      <div>
        <img src="@/assets/empty-icon.svg" alt="" width="90"/>
        <p class="el-empty-description">开发中...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'setUp',
  watch: {},
  data () {
    return {}
  },
  mounted () {

  },
  methods: {
    getStyleTemplate () {

    }
  }
}
</script>

<style scoped>
.el-empty-description {
  text-align: center;
  ont-size: 14px;
  color: #5e6d82;
  line-height: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/views/components/6/Input/setUp.vue